
export class tax {
    legalEntityGUID: string;
    legalEntityId: number;
    taxId: number;
    taxGUID: string;
    taxName: string;
    taxcode:string;
    isDefault:boolean;
    mileageUnit: string;
    mileageRate: number;
    mileageRateCurrencyId: number;
    mileageRateCurrencyCode: string;
    mileageRateCurrencyIcon: string;
    pageNumber: number;
    pageSize: number;
    sortType: any;
    sortColumn: any;
    statusId: number;
    categoryType: any;
  }
  export class taxList {
    legalEntityGUID: string;
    legalEntityId: number;
    categoryType: any;
    taxId: number;
    taxGUID: string;
    taxName: string;
    taxcode: string;
    showOnDashboard: boolean;
    mileageUnit: string;
    mileageRate: number;
    mileageRateCurrencyId: number;
    mileageRateCurrencyCode: string;
    mileageRateCurrencyIcon: string;
    pageNumber: number;
    isDefault:boolean;
    pageSize: number;
    sortType: any;
    sortColumn: any;
    statusId: number;
    constructor(list) {
      this.legalEntityGUID = list.legalEntityGUID;
      this.legalEntityId = list.legalEntityId;
      this.taxId = list.taxId;
      this.taxGUID = list.taxGUID;
      this.taxName = list.taxName;
      this.taxcode = list.taxcode;
      this.mileageUnit = list.mileageUnit;
      this.mileageRate = list.mileageRate;
      this.mileageRateCurrencyId = list.mileageRateCurrencyId;
      this.mileageRateCurrencyCode = list.mileageRateCurrencyCode;
      this.mileageRateCurrencyIcon = list.mileageRateCurrencyIcon;
      this.statusId = list.statusId;
      this.isDefault=list.isDefault;
      this.categoryType = list.categoryType;
    }
  }
  